// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"ffc108ec","69":"acd7f528","109":"f80d30a4","497":"bc225664","787":"d5c1046c","804":"5009b528"}[chunkId] + ".chunk.js";
};